<script>
  export let source_cat_dict;

  function select() {
    // console.log('source_cat_dict: ', source_cat_dict);
    // source_cat_dict[0] = source_cat_dict[0];
  }
</script>

<div class="col" style="margin-left:30px;">
  {#each source_cat_dict as ld}
    <div class="row">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          on:change={select}
          bind:checked={ld["checked"]}
          value=""
          id="flexCheckDefault{ld['short']}"
        />
        <label class="form-check-label" style="white-space: nowrap; font-size: 12px;" for="flexCheckDefault{ld['short']}">
          {ld["short"]}
        </label>
      </div>
    </div>
  {/each}
</div>

<style>
</style>
